"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _material = require("@mui/material");

var _TextButton = require("../TextButton");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["id"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var StyledDiv = (0, _material.styled)("div")(function () {
  return {
    "& button": {
      borderRadius: 0,
      marginLeft: "-1px"
    },
    "& button:first-of-type": {
      borderBottomLeftRadius: "2px",
      borderTopLeftRadius: "2px",
      marginLeft: 0
    },
    "& button:last-of-type": {
      borderBottomRightRadius: "2px",
      borderTopRightRadius: "2px"
    }
  };
});

var ToggleGroup = function ToggleGroup(_ref) {
  var buttons = _ref.buttons,
      onChange = _ref.onChange,
      value = _ref.value;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledDiv, {
    children: buttons.map(function (_ref2) {
      var id = _ref2.id,
          rest = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextButton.TextButton, _objectSpread(_objectSpread({
        id: id
      }, rest), {}, {
        onClick: function onClick(e) {
          if (id !== value && onChange) {
            onChange(e, id);
          }
        },
        size: "small",
        variant: value === id ? "contained" : "outlined"
      }), id);
    })
  });
};

var _default = ToggleGroup;
exports.default = _default;